__webpack_require__.p = "https://js-static.iimjobs.com/production/4.3.6/_next/";